import { defineMessages } from 'react-intl';

export default defineMessages({
	linkText: {
		id: 'app.ui.searchLink',
		defaultMessage: 'Search',
		description: 'The title of the search page',
	},
});
